<template>
  <div>
    <!-- <ots-main-title></ots-main-title> -->
    <div class="PlanTitle">
      <p>
        <span class="LastUrl" @click="goLast()">成绩分析</span
        ><span class="Center">/</span
        ><span class="CurrentUrl" @click="goCurrent()">成绩分析详情</span>
      </p>
    </div>
    <div class="courseName">
      <p>{{ this.info.planName }} -- {{ this.info.courseName }}</p>
    </div>
    <div class="courseInfo">
      <div class="item">
        <p class="number">{{ info.payStuCount }} <span>人</span></p>
        <p class="descript">应考人数</p>
      </div>
      <div class="line"></div>

      <div class="item">
        <p class="number">{{ info.examedStuCount }} <span>人</span></p>
        <p class="descript">参考人数</p>
      </div>
      <div class="line"></div>

      <div class="item">
        <p class="number">{{ info.unexamStuCount }} <span>人</span></p>
        <p class="descript">缺考人数</p>
      </div>
      <div class="line"></div>

      <div class="item">
        <p class="number">{{ info.unusualStuCount }} <span>人</span></p>
        <p class="descript">违纪人数</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.examedPercent }} <span>%</span></p>
        <p class="descript">参考率</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.unexamPercent }} <span>%</span></p>
        <p class="descript">缺考率</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.unusualPercent }} <span>%</span></p>
        <p class="descript">违纪率</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.passStuCount }} <span>人</span></p>
        <p class="descript">合格人数</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.excellentStuCount }} <span>人</span></p>
        <p class="descript">优秀人数</p>
      </div>

      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.passPercent }} <span>%</span></p>
        <p class="descript">合格率</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p v-if="info.excellentPercent" class="number">
          {{ info.excellentPercent }} <span>%</span>
        </p>
        <p v-else class="number">-</p>
        <p class="descript">优秀率</p>
      </div>
      <div class="line"></div>
      <div class="item">
        <p class="number">{{ info.avgScore }} <span>分</span></p>
        <p class="descript">平均分</p>
      </div>
    </div>
    <div class="achievement">
      <p>
        <span class="desc">标准差</span>
        <span class="num">{{ ChartsInfo.standardDeviation }}</span>
        <span class="desc">全距</span>
        <span class="num">{{ ChartsInfo.fullRange }}</span>
        <span class="desc">变异系数</span>
        <span class="num">{{ ChartsInfo.coefficientVariation }}</span>
      </p>
      <div v-show="isDraw" id="myChart" class="drawArea"></div>
    </div>

    <div class="mainCon">
      <p>
        成绩明细
        <el-button class="buttonexcel" @click="mainTopBtnList">导出</el-button>
      </p>

      <ots-table-group-new
        :selectList="selectList"
        :request-form="stuSelectParams"
        @search="getStudentList"
        :tableHeader="tableHeader"
        :tableData="tableData"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    </div>
  </div>
</template>
<script>
import { getnormalData } from "@/http/modules/examReport";
import { getPlanCourseFn } from "@/http/modules/baseSet/course";
import {
  getStudentScoreListFn,
  exportStudentScoreFn,
  getOtsUrlFn,
} from "@/http/modules/examSet/score";
const photoState = {
  0: "未通过",
  1: "通过",
  2: "-",
};
export default {
  data() {
    return {
      info: {},
      isDraw: true,
      ChartsData: [],
      ChartsInfo: "",

      selectList: [
        {
          title: "教学点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "stationId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证号/证件号",
          requestKey: "searchKey",
        },
        {
          title: "课程",
          type: "select",
          requestKey: "courseId",
          label: "courseName",
          value: "courseId",
          disabled: true,
          data: [],
        },
      ],
      stuSelectParams: {
        planId: this.$route.query.planId,
        courseId: [],
        searchKey: "",
        stationId: [],
        systemAuditStatus: "",
        humanAuditState: [],
        checkState: [],
        scorePublish: 1,
        placeId: [],
      },
      stuListParams: {
        page: 1,
        size: 10,
      },
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "姓名",
          prop: "realName",
        },
        {
          title: "准考证号",
          prop: "entranceCode",
        },
        {
          title: "证件号",
          prop: "cardNo",
        },
        {
          title: "教学点",
          prop: "stationName",
        },
        {
          title: "考点",
          prop: "placeName",
        },
        {
          title: "分数",
          prop: "score",
        },
        {
          title: "客观题成绩",
          prop: "objectiveScore",
        },
        {
          title: "主观题成绩",
          prop: "subjectiveScore",
        },

        {
          title: "成绩",
          prop: "publishResult",
        },
        {
          title: "系统验证",
          prop: "photoCheckState",
          formatter: (val) => photoState[val.row.photoCheckState] || "数据错误",
        },
        {
          title: "人工审核",
          prop: "humanAuditState",
        },
        {
          title: "考试状态",
          prop: "checkState",
        },
        {
          title: "考试课程",
          prop: "courseName",
        },
        {
          title: "发布状态",
          prop: "placeNames",
          formatter: (val) => (val.row.scorePublish == 1 ? "已发布" : "未发布"),
        },
        {
          title: "作答详情",
          type: "button",
          formatter: (val) => (val.row.recordId == 'scoreimport')? '':"查看",
          disableFn: (val) =>
            val.row.publishResult == "-" || val.row.checkState == "缺考"
              ? true
              : false,
          click: this.goOTS,
        },
      ],
      tableData: [],
      pagination: {
        total: 0,
      },
    };
  },
  mounted() {
    this.initData();
    this.getStudentList();
  },
  methods: {
    /*********************************
     * @initData 初始化数据
     *********************************/
    initData() {
      this.info = this.$route.query;
      let params = {
        planId: this.info.planId,
        courseId: this.info.courseId,
      };

      this.stuSelectParams.courseId = this.info.courseId;

      getnormalData(params).then((res) => {
        this.ChartsData = res.data.scoreSection;
        this.ChartsInfo = res.data;
        this.drawLine();
      });
      this.mixin_getSelectStation().then((data) => {
        let newStationList = [{ id: "", name: "全部" }, ...data];
        this.$set(this.selectList[0], "data", newStationList);
      });
      getPlanCourseFn({ planId: this.info.planId }).then(
        ({ data: courseData }) => {
          this.selectList[2].data = courseData;
        }
      );
    },

    /*********************************
     * @drawLine E-charts
     *********************************/
    drawLine() {
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      let option = {};
      let xAxisData = this.ChartsData.map((item) => item.maxScore);
      let dataInfo = this.ChartsData.map((item) => item.sectionNameCount);
      let lineData = this.ChartsData.map((item) => item.sectionNameNormal);
      let maxCount = Math.max.call(...dataInfo);
      let maxNormal = Math.max.call(...lineData);

      option = {
        title: {
          text: "成绩正态分布图",
          subtext: "（单位：人）",
        },
        formatter: function (params) {
          let firstParams = params[0];
          let Paramsss = params[1];
          return (
            "人数：" +
            firstParams.data +
            "<br>" +
            "正态分布值：" +
            Paramsss.data
          );
        },
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: xAxisData,
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#4b87a9",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            min: 0,
            max: maxCount + 10,
            position: "left",
            splitLine: {
              show: false,
            },
            axisLine: {
              onZero: false,
              lineStyle: {
                color: "#4b87a9",
              },
            },
          },
          {
            type: "value",
            position: "right",
            name: "",
            min: 0,
            max: (maxNormal * 1.2).toFixed(6),
            interval: (maxNormal * 1.2).toFixed(5) / 5,
            axisLabel: {
              formatter: "{value}",
            },
          },
        ],
        series: [
          {
            name: "人数",
            type: "bar",
            barWidth: "18%",
            data: dataInfo,
            itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#1FCCAF" },
                  { offset: 1, color: "#16B8D9" },
                ]),
              },
            },
          },
          {
            name: "正态分布",
            type: "line",
            data: lineData,
            yAxisIndex: 1,
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            itemStyle: {
              normal: {
                color: "#fff",
                borderColor: "#4bc8db",
                areaStyle: {
                  type: "default",
                  opacity: 0.4,
                },
              },
            },
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 1,
                y2: 0,
                colorStops: [
                  {
                    offset: 0,
                    color: "#006AFF", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "#006AFF", // 100% 处的颜色
                  },
                ],
                globalCoord: false, // 缺省为 false
              },
              width: 2,
            },
            areaStyle: {
              normal: {
                color: "rgba(255,255,255,0)",
              },
            },
          },
        ],
      };

      myChart.setOption(option, true);
    },

    /*********************************
     * @getStudentList 成绩详情
     *********************************/
    async getStudentList(page) {
      let params;
      if (!page) {
        this.stuListParams.page = 1;
        params = Object.assign(this.stuListParams, this.stuSelectParams);
      } else {
        params = Object.assign(this.stuTempParams, {
          page: this.stuListParams.page,
        });
      }
      if (typeof params.stationId == "object") {
        params.stationId = params.stationId.join(",");
      }
      const { data } = await getStudentScoreListFn(params);
      this.stuTempParams = params;
      this.tableData = data.records;
      this.pagination.total = data.total;
    },

    /*********************************
     * @goOTS 作答详情
     *********************************/
    async goOTS(row) {
      let params = {
        action: "getTReviewDetails",
        parames: `argumentsId=${row.recordId}&curPage=JudgeLib`,
      };
      const { code, data } = await getOtsUrlFn(params);
      if (code == 1) {
        window.open(data);
      }
    },

    // 返回"成绩分析"
    goLast() {
      this.$router.push({ name: "scoreAnalysis" });
    },

    // 刷新当前页
    goCurrent() {
      window.location.reload();
    },

    // 切换每页数量
    changeSize(num) {
      this.stuListParams.size = num;
      this.getStudentList();
    },

    // 切换页码
    changePage(p) {
      this.stuListParams.page = p;
      this.getStudentList(true);
    },
    mainTopBtnList() {
      let params = { ...this.stuSelectParams };
      params.stationId = params.stationId.join();

      exportStudentScoreFn(params).then((res) => {
        if (res.code == 1) {
          window.open(res.data);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.PlanTitle {
  margin-bottom: 24px;
  & > p {
    .LastUrl {
      color: #9299a6;
      cursor: pointer;
    }
    .Center {
      margin: 0 9px;
      font-weight: 700;
      color: #c0c4cc;
    }
    .CurrentUrl {
      font-size: 24px;
      color: #2d2f33;
      cursor: pointer;
    }
  }
}
.mainCon {
  padding: 0;
  border-top: 1px solid transparent;
  & > p {
    font-size: 18px;
    font-weight: 700;
    margin-top: 20px;
    margin-left: 20px;
    margin-bottom: 4px;
    display: flex;
    justify-content: space-between;
  }
}
.courseName {
  width: 100%;
  height: 80px;
  background: #c6d0e3;
  border-radius: 8px 8px 0px 0px;
  padding: 24px 32px;
  box-sizing: border-box;

  & > p {
    font-size: 24px;
    color: #2d2f33;
  }
}

.courseInfo {
  width: 100%;
  height: 104px;
  background: #fff;
  border-radius: 0px 0px 8px 8px;
  padding: 0 6px;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
  align-items: center;
  margin-bottom: 16px;
  .item {
    width: 152px;
    height: 100%;
    box-sizing: border-box;

    .number {
      margin-top: 20px;
      margin-bottom: 8px;
      font-size: 26px;
      color: #2d2f33;
      line-height: 32px;
      font-weight: 500;
      font-family: AlteDIN1451Mittelschrift;
      text-align: center;
      height: 40px;
      span {
        color: #737780;
        font-size: 13px;
      }
    }

    .descript {
      color: #737780;
      font-size: 13px;
      text-align: center;
    }
  }

  .line {
    width: 1px;
    height: 32px;
    border-left: 1px solid #dadde6;
  }
}
.achievement {
  height: 446px;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;

  p {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
    font-size: 13px;
    color: #737780;
    .desc {
      margin-right: 8px;
    }
    .num {
      font-size: 20px;
      color: #2d2f33;
      margin-right: 48px;
    }
  }

  .drawArea {
    width: 100%;
    height: 400px;
    // background: #2D2F33;
  }
}

.buttonexcel {
  border-radius: 20px;
  padding: 12px 23px;
  color: #fff;
  background-color: #006aff;
  border-color: #006aff;
  margin-right: 10px;
}
</style>